import React, { FC } from 'react'
import { Legend as LegendModel } from 'models/legend'
import { Color } from './components/Color'
import { Stack } from 'components/Stack'
import { CategoryPoint } from './components/CategoryPoint'
import { CategoryPolygon } from './components/CategoryPolygon'
import { Size } from './components/Size'
import { Custom } from './components/Custom'
import { Text } from 'components/Text'
import styles from './Legend.module.scss'

type LegendProps = {
  legend: LegendModel
}

const AVAILABLE_LEGENDS = {
  Color,
  Size,
  CategoryPoint,
  CategoryPolygon,
  Custom,
}

export const Legend: FC<LegendProps> = ({ legend }) => {
  const Component = AVAILABLE_LEGENDS[legend.type]

  return (
    <Stack space="small" className={styles.legend}>
      <Text weight="strong" size="small" className={styles.name}>
        {legend.name}
      </Text>
      <Component data={legend.data as any} />
    </Stack>
  )
}

Legend.displayName = 'Legend'
